import React from "react";
import { Link } from "react-router-dom";

const PatreonFooter: React.FC = () => {

  return (
    <footer className="bg-black text-white" style={{ backgroundColor: 'var(--patreon-black, #000)', color: 'var(--patreon-footer-text, #fff)' }}>
      <div className="footer-container">
        <div className="grid gap-8 grid-cols-1 lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2">
          {/* Creators Column */}
          <div>
            <div className="footer-content flex flex-col gap-5">
              <div className="footer-content-title">Creators</div>
              <div className="footer-content-link">
                <div className="content-link">
                  <Link to="/category/podcasts">Podcasters</Link>
                </div>
                <div className="content-link">
                  <Link to="/category/video">Video creators</Link>
                </div>
                <div className="content-link">
                  <Link to="/category/music">Musicians</Link>
                </div>
                <div className="content-link">
                  <Link to="/category/visualartists">Artists</Link>
                </div>
                <div className="content-link">
                  <Link to="/category/gaming">Game devs</Link>
                </div>
              </div>
            </div>
          </div>

          {/* Features Column */}
          <div>
            <div className="footer-content flex flex-col gap-5">
              <div className="footer-content-title">Features</div>
              <div className="footer-content-link">
                <div className="content-link">
                  <Link to="/features">Create on your terms</Link>
                </div>
                <div className="content-link">
                  <Link to="/features">Where real community thrives</Link>
                </div>
                <div className="content-link">
                  <Link to="/features">Grow your community</Link>
                </div>
                <div className="content-link">
                  <Link to="/features">Support for your business</Link>
                </div>
                <div className="content-link">
                  <Link to="/features">Earning made easy</Link>
                </div>
                <div className="content-link">
                  <Link to="/features">Start a membership</Link>
                </div>
                <div className="content-link">
                  <Link to="/features">Set up a shop</Link>
                </div>
              </div>
            </div>
          </div>

          {/* Pricing Column */}
          <div>
            <div className="footer-content flex flex-col gap-5">
              <div className="footer-content-title">Pricing</div>
              <div className="footer-content-link">
                <div className="content-link">
                  <Link to="/pricing">Starting a Patreon is free</Link>
                </div>
              </div>
            </div>
          </div>

          {/* Resources Column */}
          <div>
            <div className="footer-content flex flex-col gap-5">
              <div className="footer-content-title">Resources</div>
              <div className="footer-content-link">
                <div className="content-link">
                  <Link to="/resources">Creator Hub</Link>
                </div>
                <div className="content-link">
                  <Link to="/blog">Newsroom</Link>
                </div>
                <div className="content-link">
                  <Link to="/help">Help Centre & FAQs</Link>
                </div>
                <div className="content-link">
                  <Link to="/resources">Partners & integrations</Link>
                </div>
                <div className="content-link">
                  <Link to="/resources">Mobile</Link>
                </div>
              </div>
            </div>
          </div>

          {/* Company Column */}
          <div>
            <div className="footer-content flex flex-col gap-5">
              <div className="footer-content-title">Company</div>
              <div className="footer-content-link">
                <div className="content-link">
                  <Link to="/resources">About</Link>
                </div>
                <div className="content-link">
                  <Link to="/blog">Press</Link>
                </div>
                <div className="content-link">
                  <Link to="/resources">Careers</Link>
                </div>
                <div className="content-link">
                  <Link to="/legal/terms">Terms of Use & policies</Link>
                </div>
                <div className="content-link">
                  <Link to="/legal/privacy">Privacy policy</Link>
                </div>
                <div className="content-link">
                  <Link to="/legal/cookies">Cookie policy</Link>
                </div>
                <div className="content-link">
                  <Link to="/resources">Accessibility</Link>
                </div>
                <div className="content-link">
                  <Link to="/legal/terms">Impressum</Link>
                </div>
                <div className="content-link">
                  <Link to="/resources">Brand assets & guidelines</Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* App Store Badges */}
        <div className="flex gap-4 items-center my-8">
          <div>
            <img src="/assets/images/icons/playstore.png" width={150} height={150} alt="playstore" />
          </div>
          <div>
            <img src="/assets/images/icons/appstore.png" width={150} height={150} alt="appstore" />
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-copyright text-center text-white">
          600 Townsend Street, Suite 500 | San Francisco, CA 94103, USA | ©️ Patreon
        </div>
      </div>
    </footer>
  );
};

export default PatreonFooter;
